import cx from 'classnames';
import * as React from 'react';

import './styles/Row.scss';

export type RowSize = 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'small' | 'xsmall' | 'xxsmall';

type Props = {
  children?: React.ReactNode;
  flush?: boolean;
} & DefaultProps;

type DefaultProps = {
  size: RowSize;
};

export default class Row extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    size: 'medium',
  };

  render() {
    const { children, flush, size } = this.props;

    return (
      <div className={cx('Row', flush && 'Row--flush', size && `Row--${size}`)}>{children}</div>
    );
  }
}
